// public/js/modules/ui/shadingManager.js


export function setShadingLevel(level) {
    const validLevel = Math.max(0, Math.min(4, parseInt(level, 10)));

    if (isNaN(validLevel)) {
        console.warn(`[Shading] Invalid level provided: ${level}.`);
        document.body.dataset.shadingLevel = '2'; 
        return;
    }

    document.body.dataset.shadingLevel = validLevel;
}


export function setGridOpacity(level) {
    const validLevel = Math.max(0, Math.min(4, parseInt(level, 10)));

    if (isNaN(validLevel)) {
        console.warn(`[Grid Opacity] Invalid level provided: ${level}.`);
        document.documentElement.style.setProperty('--grid-opacity-multiplier', '1'); 
        document.body.dataset.gridOpacity = '3'; 
        return;
    }

    
    const multiplier = validLevel / 3;
    console.log(`[Grid Opacity] Setting level: ${validLevel}, multiplier: ${multiplier}`);
    document.documentElement.style.setProperty('--grid-opacity-multiplier', multiplier.toString());
    document.body.dataset.gridOpacity = validLevel.toString(); 
    console.log(`[Grid Opacity] CSS variable set to:`, getComputedStyle(document.documentElement).getPropertyValue('--grid-opacity-multiplier'));
}


export function initializeShading() {
    
    setShadingLevel(2);
}


export function initializeGridOpacity() {
    
    setGridOpacity(3);
}